var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeatherInterior24 = function SvgLeatherInterior24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 2s-.049 4.295 4.529 3.821L20 8.323s-4.734 3.809 0 8.6l-1.305 2.145S14.24 17.825 12.02 22h-.04c-2.225-4.175-6.675-2.932-6.675-2.932L4 16.922c4.734-4.79 0-8.599 0-8.599l1.305-2.502C9.873 6.295 9.834 2 9.834 2h4.332Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLeatherInterior24;